import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, StateKey } from './planning-profiles-store.state';

export const selectPlanningProfilesState = createFeatureSelector<State>(StateKey);

export const planningProfiles = createSelector(selectPlanningProfilesState, (state: State) => state.planningProfiles);
